import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import { store } from './store'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import axios from 'axios'

Vue.use(BootstrapVue)
Vue.config.productionTip = false
Vue.prototype.$axios = axios

new Vue({
  store,
  render: h => h(App),
}).$mount('#app')
